<template>
  <b-container class="mt-5 mb-5 rounded bg-success p-2 text-center" v-if="updateExists">
    <h5 class="text-white">نسخه جدید سایت منتشر شده است، برای دریافت آن روی گزینه "به روز رسانی" کلیک کنید.</h5>
    <span @click="refreshApp()" class="btn btn-primary">به روز رسانی</span>
  </b-container>
</template>

<script>
import UpdateSiteController from '@moeinmdn/mixitweb-front-modules/src/plugin/class/UpdateSiteController'

export default {
  name: "m-update-site-message-1",
  mixins: [UpdateSiteController],
};
</script>

<style scoped>
a { 
  text-decoration: none;
}
</style>

